export default __webpack_public_path__ + "static/media/manual_vc.ad991de4.jpeg";